function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.333 7.222V1.39h13.334v5.833h.555V.833H2.778v6.39h.555m0 6.11v5h13.334v-5h.555v5.556H2.778v-5.556h.555zm11.111 3.056v.555H5.278v-.555h9.166zm3.335-8.611l.052.022C18.34 8.018 20 8.904 20 11.18v2.084c0 2.277-1.66 3.163-2.169 3.38l-.052.023-.001-.611c.543-.277 1.666-1.058 1.666-2.792V11.18c0-1.867-1.301-2.63-1.78-2.848H2.336c-.479.218-1.78.981-1.78 2.848v2.083c0 1.734 1.123 2.515 1.666 2.792v.61l-.053-.022C1.66 16.427 0 15.541 0 13.264V11.18C0 8.904 1.66 8.018 2.169 7.8l.052-.022H17.78zm-3.335 6.666V15H5.278v-.556h9.166z",
  fill: "params(fill)",
  fillRule: "nonzero"
});

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPrint;